import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import CapsuleInformation from '@repo/ui/capsule-information'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { ReactNode } from 'react'

type Props = {
  header: ReactNode
  affected: number
  blocked: number
  total: number
  staffCount?: number
}

const InfoCardWithProgress = ({ header, affected, blocked, total, staffCount }: Props) => {
  return (
    <InnerBox className="bg-white-hover p-3">
      {header}
      <div className="h-2" />
      <div className="flex items-center gap-1">
        <CapsuleInformation
          hideTotal
          items={[
            {
              background: tailwindColors.blue.light.active,
              color: tailwindColors.blue.DEFAULT,
              value: affected,
              tooltip: 'Affectés'
            },
            {
              background: tailwindColors.fushia.light.active,
              color: tailwindColors.fushia.DEFAULT,
              value: blocked,
              tooltip: 'Bloqués'
            },
            {
              background: tailwindColors.green.light.active,
              color: tailwindColors.green.DEFAULT,
              value: total - affected - blocked,
              tooltip: 'Restants'
            }
          ]}
        />
        <Typography variant="label-semibold" color={tailwindColors.grey.DEFAULT}>
          {`(Total max :${total}${staffCount !== undefined ? ` + ${staffCount}` : ''})`}
        </Typography>
      </div>
    </InnerBox>
  )
}

export default InfoCardWithProgress
